/**
 * @generated SignedSource<<aca4ebd26f18eeb085142f8c3fb660cd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ValidateForgotUserPasswordInput = {
  token: string;
};
export type authValidateForgotUserPasswordQuery$variables = {
  input: ValidateForgotUserPasswordInput;
  skip: boolean;
};
export type authValidateForgotUserPasswordQuery$data = {
  readonly validateForgotUserPassword?: boolean;
};
export type authValidateForgotUserPasswordQuery = {
  variables: authValidateForgotUserPasswordQuery$variables;
  response: authValidateForgotUserPasswordQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "kind": "ScalarField",
        "name": "validateForgotUserPassword",
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "authValidateForgotUserPasswordQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "authValidateForgotUserPasswordQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4d4262c00500102c310bcd5fda42b754",
    "id": null,
    "metadata": {},
    "name": "authValidateForgotUserPasswordQuery",
    "operationKind": "query",
    "text": "query authValidateForgotUserPasswordQuery(\n  $input: ValidateForgotUserPasswordInput!\n  $skip: Boolean!\n) {\n  validateForgotUserPassword(input: $input) @skip(if: $skip)\n}\n"
  }
};
})();

(node as any).hash = "007877ef5cbe032dcd31dcd51edbe358";

export default node;
